
import {
  defineComponent,
  onMounted,
  watch,
  computed,
  ref,
  watchEffect,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent, DrawerComponent } from "@/assets/ts/components";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import VPagination from "@hennge/vue3-pagination";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AppService from "@/core/services/AppService";
import { renderImageUrl } from "@/core/services/AppService";
import { size_image_thumbnail } from "@/core/config/AppConfig";
import { Actions } from "@/store/enums/StoreEnums";
export default defineComponent({
  name: "account-list",
  components: { VPagination },
  props: {
    page: {
      type: String,
      default: "1",
    },
    limit: {
      type: String,
      default: "20",
    },
    link: {
      type: String,
      default: "",
    },
    order: {
      type: String,
      default: "asc",
    },
    order_by: {
      type: String,
      default: "title",
    },
    title: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    let params = {
      page: parseInt(props.page),
      limit: parseInt(props.limit),
      title: props.title,
      order: props.order,
      order_by: props.order_by,
      link: props.link,
    };
    const s_name = ref();
    const showID = ref(false);
    const modelName = "posts-search";
    const limitData = [5, 10, 20, 50, 100];
    const action_get_data = Actions.GET_ALL_POST_SEARCH;
    store.dispatch(action_get_data, AppService.convertParams(params));
    const listData = computed(() => store.getters["listDataPostSearch"]);
    const totalPages = computed(() => store.getters["getPostSearchPages"]);
    const totalDocs = computed(() => store.getters["getTotalPostSearch"]);
    const onChangePage = async (next_page) => {
      params.page = next_page;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onChangeLimit = async (event) => {
      let positionMax =
        params.limit * params.page > totalDocs.value
          ? totalDocs.value
          : params.limit * params.page;
      params.limit = event.target.value;
      params.page =
        Math.ceil(positionMax / params.limit) > 0
          ? Math.ceil(positionMax / params.limit)
          : 1;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onClickSort = async (order_by) => {
      params.order_by = order_by;
      params.order = params.order === "desc" ? "asc" : "desc";
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onSearch = async () => {
      let searchObject = {};
      // if (s_name.value.trim() != "") {
      //   searchObject["name"] = s_name.value;
      // }
      // params.search = JSON.stringify(searchObject);
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("SEO TÌM KIẾM", ["Nội dung"]);
      MenuComponent.reinitialization();
      // let searchObject = JSON.parse(params.search);
      // s_name.value = searchObject.name;
    });
    const domain_FE = process.env.VUE_APP_HOME_FE;

    return {
      s_name,
      domain_FE,
      listData,
      modelName,
      params,
      limitData,
      totalDocs,
      totalPages,
      onChangePage,
      showID,
      onChangeLimit,
      onClickSort,
      renderImageUrl,
      onSearch,
    };
  },
});
